import styled from 'styled-components';

export const Section = styled.section`
  padding: 100px 0;
  background: ${({ theme }) => theme.bgLight || '#0F0F2E'};
`;

export const Wrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 5vw;
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin-bottom: 64px;
  flex-wrap: wrap;
  gap: 12px;
`;

export const HeaderLeft = styled.div``;

export const Label = styled.p`
  font-family: 'Space Grotesk', monospace;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.24em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.primary};
  margin-bottom: 10px;
`;

export const Title = styled.h2`
  font-family: 'Space Grotesk', sans-serif;
  font-size: clamp(32px, 4vw, 52px);
  font-weight: 700;
  color: ${({ theme }) => theme.text_primary};
  letter-spacing: -0.03em;
  line-height: 1;
`;

export const TotalCount = styled.span`
  font-family: 'Space Grotesk', monospace;
  font-size: clamp(48px, 7vw, 88px);
  font-weight: 700;
  color: transparent;
  -webkit-text-stroke: 1px rgba(34, 211, 238, 0.13);
  letter-spacing: -0.04em;
  line-height: 1;
  user-select: none;
`;

/* ── Divider ───────────────────────────────────── */

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: ${({ theme }) => theme.border};
`;

/* ── Row ───────────────────────────────────────── */

export const Row = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 52px 1fr auto auto;
  align-items: center;
  gap: 20px;
  padding: 28px 0;
  cursor: pointer;
  transition: padding-left 0.3s ease;

  /* sweep background */
  &::before {
    content: '';
    position: absolute;
    inset: 0 -5vw;
    background: ${({ theme }) => theme.card};
    transform: scaleX(0);
    transform-origin: left;
    transition: transform 0.35s cubic-bezier(0.23, 1, 0.32, 1);
    z-index: 0;
  }

  &:hover { padding-left: 8px; }
  &:hover::before { transform: scaleX(1); }

  & > * { position: relative; z-index: 1; }

  @media (max-width: 640px) {
    grid-template-columns: 36px 1fr auto;
    gap: 12px;
  }
`;

export const Num = styled.span`
  font-family: 'Space Grotesk', monospace;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: ${({ theme }) => theme.primary};
  opacity: 0.45;
  transition: opacity 0.2s;

  ${Row}:hover & { opacity: 1; }
`;

export const RowTitle = styled.h3`
  font-family: 'Space Grotesk', sans-serif;
  font-size: clamp(17px, 2vw, 22px);
  font-weight: 600;
  color: ${({ theme }) => theme.text_secondary};
  letter-spacing: -0.01em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: color 0.2s;

  ${Row}:hover & { color: ${({ theme }) => theme.text_primary}; }
`;

export const TagsCell = styled.div`
  display: flex;
  gap: 6px;
  flex-wrap: nowrap;

  @media (max-width: 840px) { display: none; }
`;

export const Tag = styled.span`
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${({ theme }) => theme.primary};
  background: ${({ theme }) => theme.primary_light};
  padding: 3px 10px;
  border-radius: 100px;
  white-space: nowrap;
`;

export const Arrow = styled.span`
  font-size: 18px;
  color: ${({ theme }) => theme.text_secondary};
  transition: color 0.2s, transform 0.25s;
  flex-shrink: 0;

  ${Row}:hover & {
    color: ${({ theme }) => theme.primary};
    transform: translate(3px, -3px);
  }
`;

/* ── Floating hover preview ────────────────────── */

export const Preview = styled.div`
  position: fixed;
  width: 260px;
  height: 162px;
  border-radius: 12px;
  overflow: hidden;
  pointer-events: none;
  z-index: 9999;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.6), 0 0 0 1px rgba(34, 211, 238, 0.15);
  opacity: 0;
  transform: scale(0.86) rotate(-1.5deg);
  transition: opacity 0.22s ease, transform 0.22s ease;
  will-change: transform;
  top: 0;
  left: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  &.show {
    opacity: 1;
    transform: scale(1) rotate(-0.5deg);
  }
`;
